<template>
  <!-- 代币列表 -->
  <!-- TODO: 右对齐 -->
  <div class="token-table">
    <div class="title">
      <div class="left">
        <div>{{$t('tokenTable.title')}}</div>
        <div v-html="$t('tokenTable.showed', { showed: tableData.length })"></div>
      </div>
      <div class="right">
        <div>DNA 20</div>
      </div>
    </div>
    <div class="section">
      <div class="head">
        <div class="col">{{$t('tokenTable.rank')}}</div>
        <div class="col">{{$t('tokenTable.token')}}</div>
        <div class="col" @click="sortList('price')">{{$t('tokenTable.price')}}
          <div class="sort">
            <Icon :class="(sortProperty == 'price' && sortDirection == 1) ? 'highlight': ''" type="md-arrow-dropup" />
            <Icon :class="(sortProperty == 'price' && sortDirection == -1) ? 'highlight': ''" type="md-arrow-dropdown" />
          </div>
        </div>
        <div class="col" @click="sortList('change')">{{$t('tokenTable.change')}}
          <div class="sort">
            <Icon :class="(sortProperty == 'change' && sortDirection == 1) ? 'highlight': ''" type="md-arrow-dropup" />
            <Icon :class="(sortProperty == 'change' && sortDirection == -1) ? 'highlight': ''" type="md-arrow-dropdown" />
          </div>
        </div>
        <div class="col" @click="sortList('volume')">{{$t('tokenTable.volume')}}
          <div class="sort">
            <Icon :class="(sortProperty == 'volume' && sortDirection == 1) ? 'highlight': ''" type="md-arrow-dropup" />
            <Icon :class="(sortProperty == 'volume' && sortDirection == -1) ? 'highlight': ''" type="md-arrow-dropdown" />
          </div>
        </div>
        <div class="col" @click="sortList('marketCap')">{{$t('tokenTable.marketCap')}}
          <div class="sort">
            <Icon :class="(sortProperty == 'marketCap' && sortDirection == 1) ? 'highlight': ''" type="md-arrow-dropup" />
            <Icon :class="(sortProperty == 'marketCap' && sortDirection == -1) ? 'highlight': ''" type="md-arrow-dropdown" />
          </div>
        </div>
        <div class="col" @click="sortList('holders')">{{$t('tokenTable.holders')}}
          <div class="sort">
            <Icon :class="(sortProperty == 'holders' && sortDirection == 1) ? 'highlight': ''" type="md-arrow-dropup" />
            <Icon :class="(sortProperty == 'holders' && sortDirection == -1) ? 'highlight': ''" type="md-arrow-dropdown" />
          </div>
        </div>
        <div class="col">{{$t('tokenTable.operation')}}</div>
      </div>
      <div class="body" v-for="(item, index) in tableData" :key="index">
        <div class="col">{{index + 1}}</div>
        <div class="col">
          <img :src="item.logo" >
          <div class="intro">
            <div>{{item.name}}</div>
            <div>{{item.intro}}</div>
          </div>
        </div>
        <div class="col">{{util.formatNumber(item.price)}} USD</div>
        <div class="col" :class="item.change >= 0 ? 'up' : 'down'"><span v-if="item.change >= 0">+</span>{{item.change * 100}}%</div>
        <div class="col">
          <div>{{util.formatNumber(item.volume)}} USD</div>
          <div>{{util.formatNumber(item.volumeDna)}} DNA</div>
        </div>
        <div class="col">
          <div>{{util.formatNumber(item.marketCap)}} USD</div>
          <div>{{util.formatNumber(item.marketCapDna)}} DNA</div>
        </div>
        <div class="col">{{util.formatNumber(item.holders)}}</div>
        <div class="col">
          <router-link :to="'/tokenInfo?token=' + item.name">{{$t('tokenTable.detail')}}</router-link>
        </div>
      </div>
      <dna-spin v-if="isLoading"></dna-spin>
    </div>
  </div>
</template>

<script>
import util from '@/util/util.js'
import req from '@/req/req.js'
import dnaLogo from '@/assets/logos/dna-2.png'
export default {
  data() {
    return {
      util,
      isLoading: true,
      sortProperty: '', // 当前排序的属性 price change volume marketCap holders 默认不排序
      sortDirection: 1, // 当前排序的方向 1 升序 -1 降序
      tableData: [{
        name: 'DNA',
        logo: dnaLogo,
        intro: 'Metaverse Dualchain Network Architecture (DNA) is a parallel chain developed by the Metaverse Foundation. The DNA chain uses an innovative hybrid DPoS consensus algorithm and runs parallel to Metaverse ETP. DNA will remain decentralized while allowing for near-instant transactions and incorporating all of the features needed for a future-proofed digital finance ecosystem: integrated Lightning channels, on-chain digital identities, real-world data bridges, robust security and a standard for true interoperability. This is the most significant and ambitious upgrade to the Metaverse ecosystem to date, delivering comprehensive performance improvements.',
        price: 0.00622,
        change: 0.04,
        volume: 4564.34,
        volumeDna: 760723.43,
        marketCap: 622900000,
        marketCapDna: 1000000000,
        holders: 78494
      }]
    }
  },
  methods: {
    // 排序
    sortList(property) {
      let direction = this.sortDirection == 1 ? -1 : 1
      this.sortDirection = direction
      this.sortProperty = property
      let nList = util.sortArray(this.tableData, property, direction)
      this.tableData = nList
    }
  },
  async mounted () {
    await this.$sleep(500)
    this.isLoading = false
  }
}
</script>

<style lang="less" scoped>
@import url('./TokenTable.less');
</style>